import React from 'react';

const ComparisonIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
      fill={props.color || '#DA57C8'}
    />
    <path opacity="0.5" d="M14.59 23.12L9.16998 20V26.25L14.59 29.37V23.12Z" fill="white" />
    <path opacity="0.5" d="M20 7.5L14.59 10.62L20 13.75L25.41 10.62L20 7.5Z" fill="white" />
    <path
      opacity="0.5"
      d="M14.59 10.62L9.16998 13.75V20L14.59 23.12L20 20V13.75L14.59 10.62Z"
      fill="white"
    />
    <path
      opacity="0.5"
      d="M30.83 13.75L25.41 10.62L20 13.75V20L25.41 23.12L30.83 20V13.75Z"
      fill="white"
    />
    <path opacity="0.5" d="M25.41 23.13V29.38L30.83 26.25V20L25.41 23.13Z" fill="white" />
    <path
      opacity="0.5"
      d="M14.59 10.62L9.16998 13.75V20L14.59 23.12L20 20V13.75L14.59 10.62Z"
      fill="white"
    />
    <path opacity="0.5" d="M25.41 23.13V29.38L30.83 26.25V20L25.41 23.13Z" fill="white" />
    <path
      opacity="0.5"
      d="M20 20L14.59 23.12V29.37L20 32.5L25.41 29.37V23.12L20 20Z"
      fill="white"
    />
    <path opacity="0.5" d="M20 7.5L14.59 10.62L20 13.75L25.41 10.62L20 7.5Z" fill="white" />
    <path
      opacity="0.5"
      d="M20 20L14.59 23.12V29.37L20 32.5L25.41 29.37V23.12L20 20Z"
      fill="white"
    />
    <path opacity="0.9" d="M20 7.5L14.59 10.62L20 13.75L25.41 10.62L20 7.5Z" fill="white" />
    <path
      opacity="0.9"
      d="M20 20L14.59 23.12V29.37L20 32.5L25.41 29.37V23.12L20 20Z"
      fill="white"
    />
  </svg>
);

export default ComparisonIcon;
